import React from 'react';
import PropTypes from 'prop-types';
import { TabView } from '../TabView';
import { GCInfoRequirements } from './GCInfoRequirements';
import { CrossSell } from './CrossSell';
import { SelfGuidedTours } from './SelfGuidedTours';
import useAdvancedSettings from './useAdvancedSettings';
import { advancedSettingsPropTypes } from '../../../prop-types';
import {
  CROSS_SELL,
  GUEST_CARD_REQUIREMENTS,
  SELF_GUIDED_TOURS,
} from './constants';

const AdvancedSettings = ({ advancedSettings = {}, updateProperty }) => {
  const {
    advancedSettingsTabData,
    clearFieldErrorMessage,
    handleOnSave,
    handleOnUndo,
    isActionsDisabled,
    undoCount,
    updateAdvancedSettingsSection,
    validationErrorMessages,
  } = useAdvancedSettings({ advancedSettings, updateProperty });

  return (
    <TabView
      handleOnSave={handleOnSave}
      handleOnUndo={handleOnUndo}
      isActionsDisabled={isActionsDisabled}
    >
      <CrossSell
        crossSell={advancedSettingsTabData[CROSS_SELL]}
        key={undoCount}
        updateCrossSell={updateAdvancedSettingsSection(CROSS_SELL)}
      />

      <GCInfoRequirements
        gcInfoRequirements={advancedSettingsTabData[GUEST_CARD_REQUIREMENTS]}
        updateGCInfoRequirements={updateAdvancedSettingsSection(
          GUEST_CARD_REQUIREMENTS,
        )}
      />

      <SelfGuidedTours
        clearFieldErrorMessage={clearFieldErrorMessage}
        selfGuidedTours={advancedSettingsTabData[SELF_GUIDED_TOURS]}
        updateSelfGuidedTours={updateAdvancedSettingsSection(SELF_GUIDED_TOURS)}
        validationErrorMessages={validationErrorMessages}
      />
    </TabView>
  );
};

AdvancedSettings.propTypes = {
  advancedSettings: advancedSettingsPropTypes,
  updateProperty: PropTypes.func,
};

export default AdvancedSettings;
